const __release_version__ = 'v1.2.6';
const __customer__ = 'CFS'
const __version__ =`${__customer__}_${__release_version__}`;

module.exports = {
    __version__,
    __release_version__
}

